import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useDemo } from "@/store/DemoStore";

export default function Launcher() {
  const { status, me } = useDemo();
  if (status === "loading")
    return (
      <div className="app-shell grid place-items-center bg-[#F5F7FA]" data-testid="launcher-loading">
        <Loader2 className="h-6 w-6 animate-spin text-navy-700" />
      </div>
    );
  if (me?.kind === "client") return <Navigate to="/mytrip" replace />;
  if (me?.kind === "agent") return <Navigate to="/agent" replace />;
  return <Navigate to="/portal" replace />;
}
